import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { injectIntl, defineMessages } from 'react-intl';
import { List, Map, fromJS } from 'immutable';

import { Segment, Grid, Icon, Image, Progress, Modal } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import { TagItem, InfectionPC } from 'components';

import * as common from 'libs/commonFunc';
import * as commonVar from 'libs/commonVar';

import styles from './ExamListItem.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ExamListItemTag extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!!this.props.examListData.get('tagNo')) {
      return true;
    }
    return false;
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { indexNo, itemNo, examListData, examSummaryData, isExamTag, selectedExamList } = this.props;
    // function
    const { handleSelectExamList } = this.props;

    let infectionPercent = Number((examListData.get('infection') / examListData.get('target') * 100).toFixed(0));
    if (examListData.get('infection') > 0 && infectionPercent === 0) {
      infectionPercent = 1;
    }

    // 피싱 유도 템플릿
    const isPhishing = examListData.get('examType') === 4 ? true : false;

    const tagData = Map({
      tagNo: examListData.get('tagNo'),
      tagName: examListData.get('tagName'),
      color: examListData.get('color'),
      tagInitial: examListData.get('tagInitial'),
      createUser: examListData.get('createUser')
    });

    // 신고 대상자 수
    let declareCount = defineMessages(formatMessage({ id: 'ExamListItem_26', defaultMessage: '없음' }));
    if (examListData.get('declare') > 0) {
      if (examListData.get('declare') > 999) {
        declareCount = '+999';
      } else {
        declareCount =
          examListData.get('declare') + defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }));
      }
    }

    // 연결된 교육 수
    let eduCount = defineMessages(formatMessage({ id: 'ExamListItem_26', defaultMessage: '없음' }));
    if (examListData.get('eduByTag') > 0) {
      if (examListData.get('eduByTag') > 999) {
        eduCount = '+999';
      } else {
        eduCount =
          examListData.get('eduByTag') + defineMessages(formatMessage({ id: 'ExamListItem_10', defaultMessage: '개' }));
      }
    }

    const InnerComponent = (
      <Grid.Row textAlign="center">
        <Grid.Column className={cx('cell-isExamTag')} textAlign="center">
          {isExamTag && (
            <div className={cx('tooltip-wrapper')}>
              <Tooltip
                title={defineMessages(formatMessage({ id: 'ExamListItem_23', defaultMessage: '훈련때 선택한 태그' }))}
                placement="bottom-start">
                <Icon name="checkmark" className={cx('margin-0 brand')} />
              </Tooltip>
            </div>
          )}
        </Grid.Column>
        <Grid.Column className={cx('cell-examName')} textAlign="left">
          <div className={cx('targetItem-tagItem ellipsis')}>
            <TagItem tagItem={tagData} size="small" tooltip />
          </div>
        </Grid.Column>
        <Grid.Column className={cx('cell-infectionPercent')}>
          {examListData.get('infection') > 0 ? (
            <Tooltip
              title={
                isPhishing
                  ? defineMessages(formatMessage({ id: 'CtExamTemplateList_1', defaultMessage: '유출율' })) +
                    ': ' +
                    infectionPercent +
                    '%'
                  : defineMessages(formatMessage({ id: 'ExamListItem_17', defaultMessage: '감염율' })) +
                    ': ' +
                    infectionPercent +
                    '%'
              }
              placement="bottom">
              <div className={cx('tag-infection-status color-red')}>
                <span>{infectionPercent + '%'}</span>
                <Progress percent={infectionPercent} size="tiny" color="red" />
              </div>
            </Tooltip>
          ) : (
            <Tooltip
              title={
                isPhishing
                  ? defineMessages(formatMessage({ id: 'ExamListItem_29', defaultMessage: '안전 (유출 대상 없음)' }))
                  : defineMessages(formatMessage({ id: 'ExamListItem_18', defaultMessage: '안전 (감염 대상 없음)' }))
              }
              placement="bottom">
              <div className={cx('tag-infection-status brand-green')}>
                <span>{defineMessages(formatMessage({ id: 'ExamListItem_19', defaultMessage: '안전' }))}</span>
                <Progress percent={100} size="tiny" indicating />
              </div>
            </Tooltip>
          )}
        </Grid.Column>
        <Grid.Column className={cx('cell-infection')}>
          <div className={cx('examItem', { noLinkAttach: examListData.get('linkAttach') === 1 })}>
            <Tooltip
              title={
                defineMessages(formatMessage({ id: 'ExamListItem_3', defaultMessage: '대상' })) +
                ': ' +
                examListData.get('target')
              }
              placement="bottom">
              <div className={cx('examItem-set')}>
                <Image src={'/img/exam/chart/each_target.png'} />
                <span className={cx('examItem-count')}>{examListData.get('target')}</span>
              </div>
            </Tooltip>
            <Tooltip
              title={
                <div>
                  {examListData.get('isSuspend') === 1 &&
                    '(' +
                      defineMessages(
                        formatMessage({ id: 'ExamSummaryItem_16', defaultMessage: '메일 발송 일시정지' })
                      ) +
                      ') '}
                  {defineMessages(formatMessage({ id: 'ExamListItem_4', defaultMessage: '발송' })) +
                    ': ' +
                    (examListData.get('send') - examListData.get('sendError'))}
                  {!!examListData.get('sendReserve') &&
                    ' / ' +
                      defineMessages(formatMessage({ id: 'ExamListItem_25', defaultMessage: '발송 예약' })) +
                      ': ' +
                      (examListData.get('target') - examListData.get('send'))}
                  {!!examListData.get('sendError') &&
                    ' / ' +
                      defineMessages(formatMessage({ id: 'ExamDetailTag_48', defaultMessage: '실패' })) +
                      ': ' +
                      examListData.get('sendError')}
                </div>
              }
              placement="bottom">
              <div className={cx('examItem-set', { 'color-red': !!examListData.get('sendError') })}>
                {examListData.get('isSuspend') === 1 ? (
                  <Image src={'/img/exam/chart/each_stop.png'} />
                ) : (
                  <Image src={'/img/exam/chart/each_send.png'} />
                )}
                <span className={cx('examItem-count')}>{examListData.get('send')}</span>
              </div>
            </Tooltip>
            <Tooltip
              title={
                defineMessages(formatMessage({ id: 'ExamListItem_5', defaultMessage: '열람' })) +
                ': ' +
                examListData.get('read')
              }
              placement="bottom">
              <div className={cx('examItem-set', 'color-orange')}>
                <Image src={'/img/exam/chart/each_read.png'} />
                <span className={cx('examItem-count')}>{examListData.get('read')}</span>
              </div>
            </Tooltip>
            {(2 & examListData.get('linkAttach') || isPhishing) && (
              <Tooltip
                title={
                  (isPhishing
                    ? defineMessages(formatMessage({ id: 'ExamDetail_51', defaultMessage: '피싱 접속' }))
                    : defineMessages(formatMessage({ id: 'CtExamChart_5', defaultMessage: '파일 다운' }))) +
                  ': ' +
                  examListData.get('download')
                }
                placement="bottom">
                <div className={cx('examItem-set', 'color-down')}>
                  {isPhishing ? (
                    <Image src={'/img/exam/chart/each_access.png'} />
                  ) : (
                    <Image src={'/img/exam/chart/each_down.png'} />
                  )}
                  <span className={cx('examItem-count')}>{examListData.get('download')}</span>
                </div>
              </Tooltip>
            )}
            <Tooltip
              title={
                (isPhishing
                  ? defineMessages(formatMessage({ id: 'ExamDetail_52', defaultMessage: '정보 유출' }))
                  : defineMessages(formatMessage({ id: 'ExamListItem_6', defaultMessage: '감염' }))) +
                ': ' +
                examListData.get('infection')
              }
              placement="bottom">
              <div className={cx('examItem-set', 'color-red')}>
                {isPhishing ? (
                  <Image src={'/img/exam/chart/each_phishing.png'} />
                ) : (
                  <Image src={'/img/exam/chart/each_infection.png'} />
                )}
                <span className={cx('examItem-count')}>{examListData.get('infection')}</span>
              </div>
            </Tooltip>
            {1 === examListData.get('examType') &&
              examSummaryData &&
              2 === examSummaryData.getIn(['attachData', 'attachExamType']) && (
                <Tooltip
                  title={
                    defineMessages(formatMessage({ id: 'CtExamChart_8', defaultMessage: '치료' })) +
                    ': ' +
                    examListData.get('cure')
                  }
                  placement="bottom">
                  <div className={cx('examItem-set', 'color-cure')}>
                    <Image src={'/img/exam/chart/each_cure.png'} />
                    <span className={cx('examItem-count')}>{examListData.get('cure')}</span>
                  </div>
                </Tooltip>
              )}
          </div>
        </Grid.Column>
        <Grid.Column className={cx('cell-infectionPc')}>
          {isPhishing ? (
            <div />
          ) : (
            <div className={cx('infectionPc-area')}>
              <InfectionPC
                pcCount={examListData.get('infectionPc')}
                leakCount={examListData.get('leakAllcount')}
                leakSize={common.fileSizeTrans(examListData.get('leakAllsize')).common}
              />

              {/* <div className={cx('pcSub-set')}>
                <Tooltip
                  title={
                    defineMessages(formatMessage({ id: 'ExamListItem_9', defaultMessage: '감염 가능한 전체 파일' })) +
                    ': ' +
                    examListData.get('leakAllcount') +
                    defineMessages(formatMessage({ id: 'ExamListItem_10', defaultMessage: '개' })) +
                    ' (' +
                    common.fileSizeTrans(examListData.get('leakAllsize')).common +
                    ')'
                  }
                  placement="bottom-end">
                  <div className={cx('pcSub-item')}>
                    <div className={cx('pcSub-count')}>
                      <span className={cx('count')}>{examListData.get('leakAllcount') + ' '}</span>
                      <span className={cx('size')}>
                        ({common.fileSizeTrans(examListData.get('leakAllsize')).common})
                      </span>
                    </div>
                  </div>
                </Tooltip>
              </div> */}
            </div>
          )}
        </Grid.Column>
        {commonVar.isDeclare === 1 && (
          <Grid.Column className={cx('cell-declare')}>
            <div className={cx('declare-area')}>
              <Tooltip
                title={
                  defineMessages(formatMessage({ id: 'Declare_4', defaultMessage: '신고한 대상자' })) +
                  ': ' +
                  (examListData.get('declare') > 0
                    ? examListData.get('declare') +
                      defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' }))
                    : defineMessages(formatMessage({ id: 'ExamListItem_26', defaultMessage: '없음' })))
                }
                classes={{ tooltip: 'tooltip-noMaxWidth' }}
                placement="bottom-end">
                <div className={cx('declare-box', { existDeclare: examListData.get('declare') > 0 })}>
                  <span className={cx('declare-title')}>
                    <Image
                      src={
                        examListData.get('declare') > 0 ? '/img/declare/declare_on.png' : '/img/declare/declare_off.png'
                      }
                    />
                  </span>
                  <span>{declareCount}</span>
                </div>
              </Tooltip>
            </div>
          </Grid.Column>
        )}
        {commonVar.isEdu === 1 && (
          <Grid.Column className={cx('cell-edu')}>
            <div className={cx('edu-area')}>
              <Tooltip
                title={
                  defineMessages(formatMessage({ id: 'Edu_20', defaultMessage: '연결된 교육' })) +
                  ': ' +
                  (examListData.get('eduByTag') > 0
                    ? examListData.get('eduByTag') +
                      defineMessages(formatMessage({ id: 'ExamListItem_10', defaultMessage: '개' }))
                    : defineMessages(formatMessage({ id: 'ExamListItem_26', defaultMessage: '없음' })))
                }
                classes={{ tooltip: 'tooltip-noMaxWidth' }}
                placement="bottom-end">
                <div className={cx('edu-box', { existEdu: examListData.get('eduByTag') > 0 })}>
                  <span className={cx('edu-title')}>
                    <Image src={examListData.get('eduByTag') > 0 ? '/img/edu/edu_on.png' : '/img/edu/edu_off.png'} />
                  </span>
                  <span>{eduCount}</span>
                </div>
              </Tooltip>
            </div>
          </Grid.Column>
        )}
      </Grid.Row>
    );

    return (
      <Segment
        vertical
        className={cx('examListItem-wrapper', {
          selected:
            selectedExamList.get('isType') === 'select' && selectedExamList.get('noArray').indexOf(itemNo) !== -1
        })}
        onClick={e => {
          e.stopPropagation();

          // e.shiftKey
          handleSelectExamList(itemNo);
        }}>
        <Grid columns="equal" stackable style={{ padding: '2px 0px' }}>
          {InnerComponent}
        </Grid>
      </Segment>
    );
  }
}

export default injectIntl(ExamListItemTag);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamListItemTag.js